module.exports = __webpack_public_path__ + "static/media/English_US Linda BG-11.e7150990.png";